import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useJsApiLoader } from "@react-google-maps/api";
import Button from '../../atoms/Button/Button';
import DatePickerComponent from '../../atoms/DatePickerComponent/DatePickerComponent';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import Input from '../../atoms/Input/Input'
const LIBRARIES = ["places"];
const CitySearchLocation = ({ activeTab, onSearch, searchType, labels, modifySearch, searchData }) => {

    const navigate = useNavigate();

    const [pickup, setPickup] = useState({
        location: "",
        latitude: "",
        longitude: "",
        city: "",
        placeId:""
    });

    const [drop, setDrop] = useState({
        location: "",
        latitude: "",
        longitude: "",
        city: "",
        placeId:""
    });
    const today = new Date();

    const [pickupDate, setPickupDate] = useState(today);
    const [predictions, setPredictions] = useState([]);
    const [activeInput, setActiveInput] = useState(null);

    useEffect(() => {
        // console.log("Active Tab:", activeTab, "Search Type:", searchType);
    }, [activeTab, searchType]);
    
    useEffect(() => {
        if (searchData) {
            setPickup({
                location: 'pickup-location' in searchData ? searchData['pickup-location'] : "",
                latitude: 'pickup-latitude' in searchData ? searchData['pickup-latitude'] : "",
                longitude: 'pickup-longitude' in searchData ? searchData['pickup-longitude'] : "",
                city: 'pickup-city' in searchData ? searchData['pickup-city'] : "",
                placeId: 'pickup-place-id' in searchData ? searchData['pickup-place-id'] : "",
            });
            setDrop({
                location: 'drop-location' in searchData ? searchData['drop-location'] : "",
                latitude: 'drop-latitude' in searchData ? searchData['drop-latitude'] : "",
                longitude: 'drop-longitude' in searchData ? searchData['drop-longitude'] : "",
                city: 'drop-city' in searchData ? searchData['drop-city'] : "",
                placeId: 'drop-place-id' in searchData ? searchData['drop-place-id'] : "",
            });

            if('pickup-time' in searchData && 'pickup-date' in searchData){
                const pickupDate = searchData['pickup-date'];
                const pickupTime = searchData['pickup-time'];
                const dateTimeString = `${pickupDate}T${pickupTime}:00`;
                const pickupDateTime = new Date(dateTimeString);
                setPickupDate(pickupDateTime);
            }         
        }
    }, [searchData]);

    const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: LIBRARIES,
    });

    if (!isLoaded) return <div>Loading...</div>;
    const getTime = (date) => {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${hours}:${minutes}`;
    }

    function getDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }
    const handleDateChange = (date) => {
        if (!date) return;
        setPickupDate(date);
    };

    const isAirportPlace = (place) => {
        if (place.types.includes("airport")) {
            return true;
        } else if(place.types.includes("premise")) {
            let addressComponents = place.address_components;
            for (let i = 0; i < addressComponents.length; i++) {
                const component = addressComponents[i];

                // Check if the component relates to an airport
                if (
                    (component.types.includes('premise') && component.long_name.toLowerCase().includes('terminal')) || 
                    (component.types.includes('sublocality') && component.long_name.toLowerCase().includes('airport')) 
                ) {
                    return true;
                }
            }
        }
    }
    
    // const fetchPredictions = async (input) => {
    //     const service = new window.google.maps.places.AutocompleteService();
    //     const geocoder = new window.google.maps.Geocoder();
    
    //     let query = input;
    //     // query = activeTab === "tab1" ? `${input} airport termina` : query;
    //     if (activeTab === "tab1" && activeInput === "drop") {
    //         query = `${input} airport termina`;
    //     }
    //     service.getPlacePredictions(
    //         { input: query },
    //         (results, status) => {
    //             if (status === window.google.maps.places.PlacesServiceStatus.OK) {
    //                 Promise.all(
    //                     results.map((prediction) =>
    //                         new Promise((resolve) => {
    //                             let city = null;
    //                             let isAirport = false;
    
    //                             geocoder.geocode({ placeId: prediction.place_id }, (results, status) => {
    //                                 if (status === window.google.maps.GeocoderStatus.OK) {
    //                                     const place = results[0];
    //                                     city = place.address_components.find((component) =>
    //                                         component.types.includes("locality")
    //                                     );
    
    //                                     if (activeTab === "tab1") {
    //                                         isAirport = isAirportPlace(place);
    //                                         resolve(isAirport ? (city ? prediction : null) : null);
    //                                     } else {
    //                                         resolve(city ? prediction : null); 
    //                                     }
    //                                 } else {
    //                                     resolve(null);
    //                                 }
    //                             });
    //                         })
    //                     )
    //                 )
    //                 .then((filtered) => {
    //                     const validPredictions = filtered.filter(Boolean); 
    //                     setPredictions(validPredictions);
    //                 })
    //                 .catch((error) => {
    //                     console.error("Error processing predictions:", error);
    //                 });
    //             } else {
    //                 setPredictions([]);
    //             }
    //         }
    //     );
    // };
    
    const fetchPredictions = async (input) => {
        const service = new window.google.maps.places.AutocompleteService();
        const geocoder = new window.google.maps.Geocoder();
    
        let query = input;
   
        if (activeTab === "tab1" && activeInput === "drop") {
            query = `${input} airport termina`;
        }
    
        service.getPlacePredictions(
            { input: query },
            (results, status) => {
                if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                    Promise.all(
                        results.map((prediction) =>
                            new Promise((resolve) => {
                                let city = null;
                                let isAirport = false;
                                geocoder.geocode({ placeId: prediction.place_id }, (results, status) => {
                                    if (status === window.google.maps.GeocoderStatus.OK) {
                                        const place = results[0];
                                        city = place.address_components.find((component) =>
                                            component.types.includes("locality")
                                        );
                                        if (activeTab === "tab1") {
                                            isAirport = isAirportPlace(place);
                                            // resolve(!isAirport ?  prediction : null);
                                            if (activeInput === "pickup") {
                                                resolve(!isAirport ? prediction : null);
                                            }else{
                                                resolve(isAirport ? prediction : null);
                                            }
                                           
                                        } else {
                                            city = place.address_components.find(
                                                component=>component.types.includes("locality")
                                            );
                                            resolve(city ? prediction : null); 
                                        }
                                        
                                    } else {
                                        resolve(null);
                                    }
                                });
                            })
                        )
                    )
                    .then((filtered) => {
                        const validPredictions = filtered.filter(Boolean);
                        setPredictions(validPredictions);
                    })
                    .catch((error) => {
                        console.error("Error processing predictions:", error);
                    });
                } else {
                    setPredictions([]);
                }
            }
        );
    };
    const handleInputChange = (type, value) => {
        setActiveInput(type);
        if (type === "pickup") {
            setPickup({ ...pickup, location: value });
        } else {
            setDrop({ ...drop, location: value });
        }
        if (value) fetchPredictions(value, 'airport terminal');
        else setPredictions([]);
    };
    

    const handlePredictionSelect = (prediction) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ placeId: prediction.place_id }, (results, status) => {
            if (status === window.google.maps.GeocoderStatus.OK) {
                const place = results[0];
                const city = place.address_components.find((component) =>
                    component.types.includes("locality")
                )?.long_name;

                if (activeInput === "pickup") {
                    setPickup({
                        location: place.formatted_address,
                        latitude: place.geometry.location.lat(),
                        longitude: place.geometry.location.lng(),
                        placeId:place.place_id,
                        city: city || "",
                    });
                } else {
                    setDrop({
                        location: place.formatted_address,
                        latitude: place.geometry.location.lat(),
                        longitude: place.geometry.location.lng(),
                        placeId:place.place_id,
                        city: city || "",
                    });
                }
                setPredictions([]);
            }
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const formData = {
            "search-type": searchType,
            "pickup-location": pickup.location,
            "pickup-latitude": pickup.latitude,
            "pickup-longitude": pickup.longitude,
            "pickup-city": pickup.city,
            "pickup-place-id":pickup.placeId,
            "drop-location": drop.location,
            "drop-latitude": drop.latitude,
            "drop-longitude": drop.longitude,
            "drop-city": drop.city,
            "drop-place-id":drop.placeId,
            "pickup-date": getDate(pickupDate),
            "pickup-time": getTime(pickupDate),
        };

        try {
            let response = await onSearch(formData);

            if (response.status == true) {
                let data = response.data;

                if (data) {
                    navigate('/search-result', { state: { data: data } });
                }
                else {
                    const errorMessage = response.message || 'No data found.';
                    console.error("API Error: No data available.", errorMessage);
                    alert(`Error: ${errorMessage}`);
                }

            } else {
                const errorMessage = response.message;
                console.error("API Error:", errorMessage);
                alert(`Error: ${errorMessage}`);
            }

        } catch (error) {
            console.error("Error:", error);
        }
    };

    return (
        <>
            <form
                className="hero-section--item-container-tab-content-form"
                onSubmit={handleSubmit}

            >

                <div className='input-group '>
                    <Input
                        type="text"
                        placeholder="Enter pickup location"
                        value={pickup.location}
                        onChange={(e) => handleInputChange("pickup", e.target.value)}
                        label={labels[activeTab]?.pickup || "Pickup Location"}
                    />

                    {activeInput === "pickup" && predictions.length > 0 && (
                        <div className="hero-section--item-container-tab-content-form-dropdown">
                            {predictions.map((prediction) => (
                                <div className="hero-section--item-container-tab-content-form-dropdown--list"
                                    key={prediction.place_id}

                                    onClick={() => handlePredictionSelect(prediction)}
                                >
                                    {prediction.description}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className='input-group'>
                    <Input
                        label={labels[activeTab]?.drop || "Drop Location"}
                        type="text"
                        placeholder="Enter drop location"
                        value={drop.location}
                        onChange={(e) => handleInputChange("drop", e.target.value)}
                    />


                    {activeInput === "drop" && predictions.length > 0 && (
                        <div className="hero-section--item-container-tab-content-form-dropdown">
                            {predictions.map((prediction) => (
                                <div className="hero-section--item-container-tab-content-form-dropdown--list"
                                    key={prediction.place_id}

                                    onClick={() => handlePredictionSelect(prediction)}
                                >
                                    {prediction.description}
                                </div>
                            ))}
                        </div>
                    )}
                </div>

                <div className='input-group pe-0'>
                    <label>Pick up date & time <span style={{ color: "red" }}>*</span></label>
                    <div className="date-wrap">
                        <DatePickerComponent
                            onChange={handleDateChange}
                            value={pickupDate}
                            minDate={today}
                            showTimeSelect={true}
                        />
                        <FontAwesomeIcon icon={faCalendar} className="calendar-icon" />
                    </div>
                </div>

                <div className='input-group submitButton mb-0 ps-0'>
                    <Button
                        type="submit"
                        label={modifySearch === true ? 'Modify Search' : 'SEARCH'}
                        className="submit"
                    />
                </div>
            </form>
        </>
    );
};

export default CitySearchLocation;
